export default __webpack_public_path__ + "static/home1-b091748d1910dd67f64f4bb1b13e5872.jpg";